export default "__VITE_ASSET__CTDY2r$Y__"